async function fetchCollectionData(url) {
  try {
    const response = await fetch(url);
    const responseText = await response.text();
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(responseText, 'text/html');
    return htmlDoc;
  } catch (error) {
    console.error('Error fetching collection:', error);
    return null;
  }
}

function updateCollectionContainer(htmlDoc) {
  if (htmlDoc) {
    const productGrid = htmlDoc.getElementById('ProductGridContainer');
    console.log('vintage-values',htmlDoc.getElementById('vintage-values'));
    if ( htmlDoc.getElementById('vintage-values') == null ) {
      if (productGrid && productGrid.getAttribute('data-metatext')) {
        document.querySelector('.shop-container').innerHTML = `<h2 style="font-size: 16px;text-align: center;margin: 60px 32px;">${productGrid.getAttribute('data-metatext')}</h2>`;
      } else {
        document.querySelector('.shop-container').innerHTML = `<h2 style="font-size: 16px;text-align: center;margin: 60px 32px;">Currently no products for this category are available</h2>`;
      }
    } else {
      const vintageFilterValues = htmlDoc.getElementById('vintage-values').dataset.vintageFilters;
      const productCount = htmlDoc.getElementById('ProductCount').innerHTML;
      appendVintageFilters(vintageFilterValues);
      document.querySelector('.shop-container').innerHTML = productGrid.outerHTML;
      updateProductCount(productCount);
    }
    updateCollectionShortDescription(productGrid);
    
  } else {
    console.error('Failed to update collection container.');
  }
}

function updateCollectionShortDescription(productGrid) {
  const collectionDescriptionElement = document.querySelector('.collection_short-description');
  
  if (collectionDescriptionElement && productGrid) {
    const shortDescription = productGrid.getAttribute('data-short-description');
    
    if (shortDescription && shortDescription.trim() !== '') {
      collectionDescriptionElement.innerHTML = shortDescription;
      collectionDescriptionElement.style.display = 'block';
    } else {
      collectionDescriptionElement.innerHTML = '';
      collectionDescriptionElement.style.display = 'none';
    }
  }
}

async function outputCollection(collectionTitle, sortingOption, page = null, filter = null) {
  let url = `${window.Shopify.routes.root}collections/${collectionTitle}?sort_by=${sortingOption}`;
  
  if (page) {
    url += `&page=${page}`;
  }

  const activeYearFilter = filter || new URLSearchParams(window.location.search).get('year');
  if (activeYearFilter) {
    url += `&filter.p.m.specifications.year=${activeYearFilter}`;
  }

  const htmlDoc = await fetchCollectionData(url);
  updateCollectionContainer(htmlDoc);
  return htmlDoc ? htmlDoc.getElementById('ProductGridContainer') : null;
}


function updateUrlParams(params) {
  const urlParams = new URLSearchParams(window.location.search);
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      urlParams.set(key, value);
    } else {
      urlParams.delete(key);
    }
  });
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
}

function removeActiveClasses() {
  document.querySelectorAll('.shop-titles__item.active').forEach(element => {
    element.classList.remove('active');
  });
}

async function outputActiveCollection() {
  const sortingOption = document.getElementById('SortBy').value;
  const urlParams = new URLSearchParams(window.location.search);
  let collectionHandle = urlParams.get('collection');
  const yearFilter = urlParams.get('year') || null;
  
  let activeCollectionTitleElement = document.querySelector(`.shop-titles__item[data-key="${collectionHandle}"]`);
  if (!activeCollectionTitleElement) {
    activeCollectionTitleElement = document.querySelector('.shop-titles__item.active') || document.querySelector('.shop-titles__item');
    collectionHandle = activeCollectionTitleElement.getAttribute("data-key");
    updateUrlParams({ collection: collectionHandle, sort_by: sortingOption });
  }

  if (activeCollectionTitleElement) {
    removeActiveClasses();
    activeCollectionTitleElement.classList.add('active');
    const outputCollectionData = await outputCollection(collectionHandle, sortingOption, null, yearFilter);
    document.getElementById('collection_title').innerText = `Collections / ${activeCollectionTitleElement.dataset.collectionTitle}`;
    document.querySelector('.shop-container').innerHTML = outputCollectionData.outerHTML;
    updatePageChange();
  }
}

async function updateOnSortingChange() {
  const sortingOption = document.getElementById('SortBy');
  sortingOption.addEventListener('change', async () => {
    const activeCollectionTitleElement = document.querySelector('.shop-titles__item.active');
    if (activeCollectionTitleElement) {
      const collectionTitle = activeCollectionTitleElement.getAttribute("data-key");
      await outputCollection(collectionTitle, sortingOption.value);
      updateUrlParams({ collection: collectionTitle, sort_by: sortingOption.value, page: null });
      updatePageChange(); 
    }
  });
}

async function updateOnCollectionChange() {
  const collectionTitles = document.querySelectorAll(".shop-titles__item");
  collectionTitles.forEach(collection => {
    collection.addEventListener('click', async () => {
      if (!collection.classList.contains('active')) {
        removeActiveClasses();
        collection.classList.add('active');
        const sortingOption = document.getElementById('SortBy').value;
        const collectionTitle = collection.getAttribute("data-key");
        const yearFilter = new URLSearchParams(window.location.search).get('year');
        await outputCollection(collectionTitle, sortingOption, null, yearFilter);       
        updateUrlParams({ collection: collectionTitle, sort_by: sortingOption, year: yearFilter, page: null });
        document.getElementById('collection_title').innerText = `Collections / ${collection.dataset.collectionTitle}`;
        updatePageChange(); 
      }
    });
  });
}

async function updatePageChange() {
  const paginationButtons = document.querySelectorAll('.pagination__item.link');
  paginationButtons.forEach(button => {
    button.href = '';
    button.addEventListener('click', async event => {
      event.preventDefault();
      const urlParams = new URLSearchParams(window.location.search);
      const collectionTitle = urlParams.get("collection");
      const sortingOption = urlParams.get("sort_by");
      const activeYearFilter = urlParams.get('year') || null;
      const page = button.innerText;

      await outputCollection(collectionTitle, sortingOption, page, activeYearFilter);
      updateUrlParams({ page });
      updatePageChange();
    });
  });
  setActiveFilter();
}

function closeFilter() {
  document.addEventListener('click', (event) => {
    const filterElement = document.querySelector('.facet-filters__vintage[open]');
    
    if (filterElement && !filterElement.contains(event.target)) {
      filterElement.removeAttribute('open');
    }
  });
}

function setActiveFilter() {
  document.querySelector('.facet-filters__vintage[open]')?.removeAttribute('open');
  const urlParams = new URLSearchParams(window.location.search);
  const activeYearFilter = urlParams.get('year');
  const yearFilter = document.querySelector(`.facet-filters__filter-item--dv[data-value="${activeYearFilter}"]`);
  if (yearFilter && activeYearFilter) {
    yearFilter.classList.add('active');
  }
}

function updateProductCount(productCount) {
  const productCountElement = document.querySelector('.shop-settings__count');
  productCountElement.innerHTML = productCount;
}

async function appendVintageFilters(values) {
  const parentEl = document.querySelector('.facet-filters__filter--dv');
  parentEl.innerHTML = '';

  values.split(',').forEach(value => {
    const valueEl = document.createElement('div');
    valueEl.className = 'facet-filters__filter-item--dv';
    valueEl.dataset.value = value;
    valueEl.textContent = value;

    valueEl.addEventListener('click', async () => {
      const collectionTitle = new URLSearchParams(window.location.search).get("collection");
      const sortingOption = document.getElementById('SortBy').value;
      if (valueEl.classList.contains('active')) {
        updateUrlParams({ page: null, year: null });
        await outputCollection(collectionTitle, sortingOption);
      } else {
        updateUrlParams({ page: null, year: value });
        await outputCollection(collectionTitle, sortingOption, null, value);
      }
      updatePageChange();
    });

    parentEl.appendChild(valueEl);
  });

  const resetButton = document.createElement('p');
  resetButton.className = 'facet-filters__reset--dv text--no-margin paragraph--xs';
  resetButton.textContent = 'Clear filter';
  resetButton.addEventListener('click', async () => {
    if (new URLSearchParams(window.location.search).get('year')) {
      const collectionTitle = new URLSearchParams(window.location.search).get("collection");
      const sortingOption = document.getElementById('SortBy').value;
      updateUrlParams({ page: null, year: null });
      await outputCollection(collectionTitle, sortingOption);
      updatePageChange();
    }
  })
  parentEl.appendChild(resetButton);
}


function updateNegativeMargin() {
  const element = document.getElementById('dynamicMarginElement');
  if (element) {
    const elementHeight = element.offsetHeight;
    element.parentElement.style.marginTop = `-${elementHeight}px`;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  outputActiveCollection();
  updateOnSortingChange();
  updateOnCollectionChange();
  updateNegativeMargin();
  closeFilter();
  window.addEventListener('resize', updateNegativeMargin);
});